
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexdlfMVc2GcY0ODQAElqCEZRPlm_i41m5sjKXD1ddl88sMeta } from "/tmp/tmpf2ajrh1g/pages/index.vue?macro=true";
import { default as index_45RdJSMQRrmuovz4Hxsw3k1Z18QuexjjIxrCoLUqIEbIMeta } from "/tmp/tmpf2ajrh1g/pages/[rvrsys]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmpf2ajrh1g/pages/index.vue")
  },
  {
    name: "rvrsys",
    path: "/:rvrsys()",
    component: () => import("/tmp/tmpf2ajrh1g/pages/[rvrsys]/index.vue")
  }
]